import * as React from 'react'
import { closeConfirmModal } from '../../store/modals/actions'
import ModalHeader from './Parts/ModalHeader'
import ModalWindow from './Parts/ModalWindow'
import ModalMiddle from './Parts/ModalMiddle'
import { AppState } from '../../store'
import { AnyAction, Dispatch } from 'redux'
import { connect } from 'react-redux'
import ModalContent from './Parts/ModalContent'
import styled, { css } from 'styled-components'
import { Style } from '../../styles'
import showdown from '../../utilities/showdown'
import { withTranslation, WithTranslation } from 'react-i18next'
import { CurrentUser } from '../../types'



const ConfirmModalWindow = styled(ModalWindow)`
	max-width: 500px;

	@media screen and (max-width: ${Style.breakpoints.SMALL}){
		max-width: initial;
	}
`

const Description = styled.div`
  font-size: 16px;
`

const Action = styled.div<ActionProps>`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	min-height: 55px;
	flex: 1;
	background: #F7F6FB;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 250ms linear;

	${props => props.primary && css`
		background-color: ${Style.color.brandSuccess};
		color: #FFFF;
		font-weight: 600;

		&:hover {
			background-color: #55e200;
		}
	`}

	${props => props.destructive && css`
		background-color: ${Style.color.brandDanger};
		color: #FFFF;
		font-weight: 600;

		&:hover {
			background-color: #ff5a5a;
		}
	`}
`

const Actions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	${Action}:first-child {
		border-bottom-left-radius: ${Style.variables.baseBorderRadius};
	}

	${Action}:last-child {
		border-bottom-right-radius: ${Style.variables.baseBorderRadius};
	}
`

interface ActionProps {
  primary?: boolean
  destructive?: boolean
}

export interface ConfirmModalAction {
  label: string
  isDestructive?: boolean
}

interface IStateToProps {
  currentUser: CurrentUser
  title: string
  description: string
  action: ConfirmModalAction
  onConfirm: () => void
  onCancel?: () => void
}

interface IDispatchToProps {
  close: typeof closeConfirmModal
}

type IProps = IDispatchToProps & IStateToProps & WithTranslation

class ConfirmModal extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)

    this.onCloseClick = this.onCloseClick.bind(this)
  }

  onCloseClick() {
    const { close, onCancel } = this.props


    if (onCancel) onCancel()

    close()
  }

  render() {
    const {
      title,
      description,
      action,
      onConfirm,
      close,
      t
    } = this.props

    return (
      <ConfirmModalWindow>
        <ModalHeader title={title} onCloseClick={this.onCloseClick} />
        <ModalMiddle>
          <ModalContent>
            <Description>
              <p dangerouslySetInnerHTML={{ __html: showdown.makeHtml(description) }} />
            </Description>
          </ModalContent>

          <Actions>
            <Action onClick={this.onCloseClick}>
              {t('ConfirmModal::Cancel')}
            </Action>

            {action && <Action
              primary={true}
              destructive={action.isDestructive}
              onClick={() => {
                onConfirm()
                close()
              }}
            >
              {action.label}
            </Action>}
          </Actions>
        </ModalMiddle>
      </ConfirmModalWindow>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser
    },
    modals: {
      confirmModal: {
        title,
        description,
        action,
        onConfirm,
        onCancel,
      }
    }
  } = state

  return {
    currentUser: currentUser,
    title,
    description,
    action,
    onConfirm,
    onCancel,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    close: () => dispatch(closeConfirmModal()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmModal))